import React from 'react';
import { Box } from '../Box';
import type { PopoverProps } from '../Popover';
import { Popover } from '../Popover';
import { UIStyling } from '../styles/UIStyling';
import { PopoverPlacements, UIColors, UIShapes, UISizes, UIVariants } from '../types/UI';
import { cn } from '../utils/classnames';

export type TooltipProps = Omit<PopoverProps, 'trigger'> & {
  text: React.ReactNode;
};

export function Tooltip({
  children,
  text,

  hoverProps = { delay: 300 },
  arrow = true,
  offset = 10,
  useHover = true,
  placement = PopoverPlacements.Top,

  // ----- Themable props defaults
  color = UIColors.default,
  size = UISizes.md,
  variant = UIVariants.solid,
  shape = UIShapes.rounded,
  colorShadows,
  gradient,
  elevation,

  ...otherProps
}: TooltipProps): React.ReactElement {
  const popoverProps = { hoverProps, arrow, offset, useHover, placement };

  const themableProps = { variant, color, shape, size, gradient, elevation, colorShadows };

  return (
    <Popover {...otherProps} {...themableProps} {...popoverProps} trigger={children}>
      <Box noPad className={cn(UIStyling.paddings(themableProps))} {...themableProps}>
        {text}
      </Box>
    </Popover>
  );
}
